const SEO = ({
  title,
  description,
  children,
  prefixPath = '/abrir-conta/',
}) => {
  const SEO = {
    title: title
      ? `Banco Itaú | ${title}`
      : 'Abra sua Conta Itaú Online | Segurança e Praticidade',
    description:
      description ??
      'Abra sua conta Itaú online. Rápido, seguro e sem sair de casa. Tenha uma conta que rende automaticamente com a segurança do app Itaú.',
  };

  return (
    <>
      <title>{SEO.title}</title>
      <link
        rel="icon"
        type="image/png"
        href={`${prefixPath}favicon-itaucard.ico`}
        sizes="32x32"
      />
      <meta name="description" content={SEO.description} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#FFFFFF" />
      {children}
    </>
  );
};

export default SEO;
